<div class="d-flex justify-content-end mb-2">
  <ng-content></ng-content>
</div>

<div class="border rounded">
  <ng-container
    *ngIf="
      language === 'html' || language === 'markdown';
      else monacoEditorTemplate
    "
  >
    <div class="row no-gutters">
      <div class="col-6">
        <ng-container *ngTemplateOutlet="monacoEditorTemplate"></ng-container>
      </div>
      <div class="col-6">
        <div class="p-3" [style.height]="height" style="overflow: auto">
          <ng-container [ngSwitch]="language">
            <div
              *ngSwitchCase="'html'"
              [innerHTML]="code | shBypassSecurityTrustHtml"
            ></div>
            <sh-markdown-preview
              *ngSwitchCase="'markdown'"
              [value]="code"
            ></sh-markdown-preview>
          </ng-container>
        </div>
      </div>
    </div>
  </ng-container>
</div>

<ng-template #monacoEditorTemplate>
  <div class="overflow-hidden" [style.height]="height">
    <nu-monaco-editor
      [(ngModel)]="code"
      [options]="editorOptions"
      class="h-100"
    ></nu-monaco-editor>
  </div>
</ng-template>
